import {
  PROFILE_TAB_ACTIVITY_MONTHS,
  PROFILE_TAB_POST_LIMIT,
  profileTabKeys,
} from "@/lib/query-keys/profile-tabs";

export const profileKeys = {
  all: ["profile-hub"] as const,
  requestContext: () => [...profileKeys.all, "request-context"] as const,
  currentProfile: () => ["profile", "current"] as const,
  viewer: () => [...profileKeys.all, "viewer"] as const,
  activityDefinitions: () =>
    [...profileKeys.all, "activity-definitions"] as const,
  userPosts: (userId: string, limit = PROFILE_TAB_POST_LIMIT) =>
    profileTabKeys.userPosts(userId, true, limit),
  userActivityPosts: (userId: string, limit = PROFILE_TAB_POST_LIMIT) =>
    profileTabKeys.userActivityPosts(userId, true, limit),
  activitiesOverview: (userId: string, months = PROFILE_TAB_ACTIVITY_MONTHS) =>
    profileTabKeys.activitiesOverview(userId, months),
};
